import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DiagnosticsComponent} from '@app/modules/diagnostics/components/diagnostics/diagnostics.component';
import {
  DiagnosticsLoginPageComponent
} from '@app/modules/diagnostics/components/diagnostic-enter-page/diagnostics-login-page.component';
import {SharedModule} from '@app/modules/shared/shared.module';
import {FormsModule} from '@angular/forms';
import { DiagnosticsReportComponent } from './components/diagnostics-report/diagnostics-report.component';
import {NgbDatepickerModule} from '@ng-bootstrap/ng-bootstrap';


@NgModule({
  declarations: [
    DiagnosticsComponent,
    DiagnosticsLoginPageComponent,
    DiagnosticsReportComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    NgbDatepickerModule
  ]
})
export class DiagnosticsModule { }
